import React, {useContext, useEffect, useRef} from 'react';
import {Form, Formik} from 'formik';
import {Button, FormHelperText, TextField} from '@material-ui/core';
import * as Yup from 'yup';
import {ThemeContext} from '../../../themes/ThemeProvider';
import {useSelector, useDispatch} from 'react-redux';
import {
  fetchLookupDetails,
  postLookUPValueData,
  resetLookUpValueData,
} from '../../../redux/reducers/LookupMaintenance/AddLookup';
import {upperCaseCode} from '../../../components/UpperCaseCode';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';
const AddValueForm = ({handleLookupClose, rowEditData, isEditMode, rowData}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {successMsg, errorMsg, lookupDetailsData} = useSelector(
    ({addLookupMaintenance}) => addLookupMaintenance,
  );
  const dispatch = useDispatch();
  const codeRef = useRef();
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const checkTranslationCodeExist = (value, type) => {
    const data = rowEditData?.valueCode ?
      lookupDetailsData?.filter(
        (el) =>
          el?.valueCode?.toUpperCase()?.trim() !== rowEditData?.valueCode?.toUpperCase()?.trim(),
      ) :
      lookupDetailsData;

    if (data?.length > 0 && value) {
      const titleData = [];
      data?.forEach((i) => {
        if (
          i?.valueCode?.toString()?.toUpperCase()?.trim() ===
          value?.toString()?.toUpperCase()?.trim()
        ) {
          titleData.push(i);
        }
      });
      return titleData.length > 0;
    } else {
      return false;
    }
  };
  const schema = Yup.object().shape({
    code:
      // isEditMode && rowEditData?.typeCode
      //   ? null
      //   :
      Yup.mixed()
        .test('code', 'Code is required', (value) => {
          if (!value) {
            return false;
          } else {
            return true;
          }
        })
        .test('code', 'Code already exist', (value) => !checkTranslationCodeExist(value)),
    value:
      isEditMode && rowEditData?.value ?
        null :
        Yup.mixed().test('value', 'Value is required', (value) => {
          if (!value) {
            return false;
          } else {
            return true;
          }
        }),
  });
  useEffect(() => {
    if (successMsg) {
      setTimeout(() => {
        dispatch(resetLookUpValueData());
        handleLookupClose();
      }, 2500);
      dispatch(fetchLookupDetails(rowData?.typeCode));
    }
  }, [successMsg]);
  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetLookUpValueData());
      }, 2500);
    }
  }, [errorMsg]);
  const initialValues = {
    code: isEditMode && rowEditData?.valueCode ? rowEditData?.valueCode : '',
    value: isEditMode && rowEditData?.value ? rowEditData?.value : '',
    lookupFrom: null,
    lookupTo: null,
  };
  const handleSubmit = (values) => {
    dispatch(submissionStart());
    const payload = {
      effectiveFrom: '',
      effectiveTo: '',
      id: rowEditData?.id ? rowEditData?.id : 0,
      seqNo: '',
      typeCode: rowData?.typeCode ? rowData?.typeCode : '',
      value: values?.value ? values?.value : '',
      valueCode: values?.code ? values?.code : '',
    };
    dispatch(postLookUPValueData(payload));
  };
  return (
    <div className={classes.addRule}>
      <div className={classes.dialoguecardStyles}>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          validationSchema={schema}
          enableReinitialize
        >
          {(props) => {
            const {
              values,
              setFieldValue,
              touched,
              errors,
              resetForm,
              handleBlur,
            } = props;
            return (
              <>
                <div>
                  <Form autoComplete="off" noValidate>
                    <div className="form-row global-field-textfields new-standard-textfields ">
                      <div className="col-sm-6 col-md-4 col-xl-6 form-group">
                        <TextField
                          className={` ${classes.labelName}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Code`}
                          label={`Code`}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          name="code"
                          inputRef={codeRef}
                          required
                          value={values?.code}
                          onChange={(e) => {
                            const value = upperCaseCode(codeRef);
                            setFieldValue('code', value);
                          }}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.code}
                          error={Boolean(touched.code && errors.code)}
                        />
                        <FormHelperText>
                          {touched.code && errors?.code && errors.code}
                        </FormHelperText>
                      </div>
                      <div className="col-sm-6 col-md-4 col-xl-6 form-group">
                        <TextField
                          className={` ${classes.labelName}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Value`}
                          label={`Value`}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          name="value"
                          required
                          value={values?.value}
                          onChange={(e) => {
                            setFieldValue('value', e.target.value);
                          }}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.value}
                          error={Boolean(touched.value && errors.value)}
                        />
                        <FormHelperText>
                          {touched.value && errors?.value && errors.value}
                        </FormHelperText>
                      </div>
                    </div>
                    {/* <div className="form-row global-field-textfields ">
                      <div className="col-sm-6 col-md-4 col-xl-6 form-group">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            // className={`${classes.datePicker} ${classes.labelName}`}
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            fullWidth
                            value={values?.lookupFrom}
                            name="lookupFrom"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            onBlur={handleBlur}
                            inputVariant="outlined"
                            helperText=""
                            label="From"
                            onChange={(val) => {
                              setFieldValue("lookupFrom", val);
                            }}
                            autoOk
                            margin="dense"
                            touched={touched?.lookupFrom}
                            error={Boolean(touched?.lookupFrom && errors?.lookupFrom)}
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                      <div className="col-sm-6 col-md-4 col-xl-6 form-group">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            // className={`${classes.datePicker} ${classes.labelName}`}
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            fullWidth
                            value={values?.lookupTo}
                            name="lookupTo"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            onBlur={handleBlur}
                            inputVariant="outlined"
                            helperText=""
                            label="To"
                            onChange={(val) => {
                              setFieldValue("lookupTo", val);
                            }}
                            autoOk
                            margin="dense"
                            touched={touched?.lookupTo}
                            error={Boolean(touched?.lookupTo && errors?.lookupTo)}
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                    </div> */}

                    <div className="d-flex justify-content-center new-standard-textfields">
                      <Button
                        variant="outlined"
                        onClick={() => {
                          resetForm(initialValues);
                        }}
                        className={`mx-1 reset-btn ${classes.buttonRoot}`}
                      >
                        Reset
                      </Button>
                      <Button
                        variant="outlined"
                        type="submit"
                        className={`search-btn mx-1 ${classes.buttonRoot}`}
                        disabled={enabledSubmission}
                      >
                        Save
                      </Button>
                    </div>

                    {/* <div className="form-row global-field-textfields new-standard-textfields ">

                    </div> */}
                  </Form>
                </div>
              </>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default AddValueForm;
